import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=2b67af5e&scoped=true"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"
import style0 from "./YouTubeVideo.vue?vue&type=style&index=0&id=2b67af5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67af5e",
  null
  
)

export default component.exports